import React from 'react';
import About from './About';
import Contact from './Contact';
import Hero from './Hero';
import Portfolio from './Portfolio';
import Skills from './Skills';

const Main = () => {
    return (
        <div>
            <Hero />
            <About />
            <Skills />
            <Portfolio />

            <Contact />
        </div>
    );
};

export default Main;